const columns = () => {
  return [
    {
      title: "名称",
      name: "name",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "状态",
      name: "state",
      searchItem: {
        type: "select"
      },
      tableItem: {
        width: 300
      },
      dict: [
        {code: 0, codeName: "无效"},
        {code: 1, codeName: "有效"}
      ],
    },
    {
      title: "创建时间",
      name: "createTime",
      tableItem: { 
        width: 300
      }
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'questionType/normalListByPage',
    ...api
  }
}

const questionType = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    tableApi: tableApi(api)
  }
}

export default questionType
